import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, useSectionView } from './shared';

const OUTCOMES = [
  { title: 'One priority, one campaign', body: 'Turn one marketing priority into a coordinated campaign across your channels.' },
  { title: 'Strategy and assets together', body: 'Create the strategy and the supporting assets in the same workspace.' },
  { title: 'From unclear to actionable', body: 'Move from an unclear idea to a marketing plan you can act on.' },
  { title: 'Connected, not scattered', body: 'Content, campaigns and next actions stay linked, not spread across six tools.' },
];

export const ProofStrip = () => {
  const ref = useSectionView('proof_strip');
  return (
    <section ref={ref} style={{ padding: 'clamp(48px, 6vw, 80px) clamp(20px, 5vw, 48px)', borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`, background: 'rgba(255,255,255,0.012)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <FadeUp>
          <p style={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: '0.22em', color: C.muted, textTransform: 'uppercase', textAlign: 'center', marginBottom: 36 }}>
            Early-access product &middot; Built with early-stage founders
          </p>
        </FadeUp>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(230px, 100%), 1fr))', gap: 16 }}>
          {OUTCOMES.map((o, i) => (
            <FadeUp key={i} delay={i * 80}>
              <div className="scl-card" style={{ padding: '24px 22px', border: `1px solid ${C.border}`, borderRadius: 14, background: C.surface, height: '100%' }}>
                <div style={{ width: 20, height: 2, background: C.lime, marginBottom: 16 }} />
                <p style={{ fontFamily: DISP, fontWeight: 700, fontSize: 16, color: C.text, marginBottom: 8 }}>{o.title}</p>
                <p style={{ fontFamily: BODY, fontSize: 14, lineHeight: 1.65, color: C.body }}>{o.body}</p>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={320}>
          <p style={{ marginTop: 28, textAlign: 'center', fontFamily: BODY, fontSize: 13.5, color: C.muted, maxWidth: 640, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.7 }}>
            ScalitOS is currently being tested by a small group of founders and business owners. Verified founder results will be published here as they come in.
          </p>
        </FadeUp>
      </div>
    </section>
  );
};
